module.exports = __webpack_public_path__ + "stylesheets/global_3a21225891addfde5702e584390a34f4.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 153